import { NgClass } from "@angular/common";
import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-checkbox-item",
    templateUrl: "./checkbox-item.component.html",
    styleUrls: ["./checkbox-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class CheckboxItemComponent {

  @Input() label: string;
  @Input() key: any;
  @Output() checkedChange = new EventEmitter();
  @Input() checked?: boolean;
  @Input() disabled?: boolean;
  @Input() negative?: boolean;
  @HostListener("click") onClick() {
      if (this.disabled) {
          return;
      }
      this.checked = !this.checked;
      this.checkedChange.emit([
          this.key,
          this.checked,
          false
      ]);
  }
}
